import { useState, useRef } from 'react';

interface UseQRScannerProps {
  onScan?: (result: string) => void;
  onClose?: () => void;
  isOpen?: boolean;
}

interface UseQRScannerResult {
  error: string | null;
  scanned: boolean;
  resetScanned: () => void;
  handleScan: (result: string) => void;
  handleError: (error: unknown) => void;
  setError: (error: string | null) => void;
}

/**
 * QRコードスキャナーを制御するカスタムHook
 */
export const useQRScanner = ({
  onScan,
  onClose,
  isOpen,
}: UseQRScannerProps): UseQRScannerResult => {
  const [error, setError] = useState<string | null>(null);
  const [scanned, setScanned] = useState(false);
  const hasScannedRef = useRef(false);

  // スキャン状態をリセットする関数
  const resetScanned = () => {
    setScanned(false);
    hasScannedRef.current = false;
  };

  // QRコードがスキャンされた時の処理
  const handleScan = (result: string) => {
    // 重複スキャンを防ぐ
    if (hasScannedRef.current) return;

    hasScannedRef.current = true;
    setScanned(true);
    onScan?.(result);
  };

  // エラーハンドリング
  const handleError = (err: unknown) => {
    console.error('QRスキャナーエラー:', err);
    if (err instanceof Error && err.name === 'NotAllowedError') {
      setError('カメラへのアクセスが拒否されました');
    } else {
      setError('カメラの初期化に失敗しました');
    }
  };

  return {
    error,
    scanned,
    resetScanned,
    handleScan,
    handleError,
    setError,
  };
};
